import { c as _c } from "react/compiler-runtime";
import { FilterToolbarClearAll } from "@components/common/faro-table/faro-table-filter/filter-toolbar-clear-all";
import { Stack } from "@mui-wrapper";
import { Fragment } from "react";
/** Row with the filter chips of a table, followed by the button to clear them */
export function FilterChipsBar(t0) {
  const $ = _c(6);
  const {
    filterChips
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      alignItems: "center",
      flexWrap: "wrap",
      gap: 1
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== filterChips) {
    t2 = Object.values(filterChips).filter(_temp).map(_temp2);
    $[1] = filterChips;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <FilterToolbarClearAll />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <Stack direction="row" sx={t1}>{t2}{t3}</Stack>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}
function _temp2(filterChip_0, index) {
  return <Fragment key={index}>{filterChip_0}</Fragment>;
}
function _temp(filterChip) {
  return filterChip !== null;
}